import { createFileRoute } from '@tanstack/react-router'
import UserContainer from 'User/containers/UserContainer'
import { userQueries } from 'User/utils/queries'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard } from '../-guard'
import { prefetchWhenAuthenticated } from '../-prefetch'

export const Route = createFileRoute('/user/$userId')({
    loader: ({ context, params }) =>
        prefetchWhenAuthenticated(context.queryClient, userQueries.detail(params.userId)),
    pendingComponent: () => <PageSkeleton variant="detail" />,
    component: () => (
        <Guard claims={['opus_user']}>
            <UserContainer />
        </Guard>
    ),
})
